import React, { useEffect } from 'react';
import ApiBase from "./api/apiBase";
import {CssBaseline, ThemeProvider} from "@mui/material";
import {useRoutes} from "react-router-dom";
import Routes from "./routes/Routes";
import {AppDispatch, useSelector} from "./redux/store";
import {ThemeSettings} from "./theme/Theme";

import ScrollToTop from "./components/scrollToTop/ScrollToTop";
import CacheService from "./services/CacheService";
import { login } from './redux/actions/authActions';
import { jwtDecode } from 'jwt-decode';
import 'leaflet/dist/leaflet.css';
import './styles/fonts.css';

// JWT token interface
interface CustomJwtPayload {
	exp: number;
	iss: string;
	nbf: number;
	'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier': string;
	'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress': string;
	'http://schemas.microsoft.com/ws/2008/06/identity/claims/role': string;
	permissions: string[];
}

function App() {
	const routing = useRoutes(Routes());
	const theme = ThemeSettings();
	const dispatch = AppDispatch();
	
	useEffect(() => {
		const authToken = localStorage.getItem('authToken');
		const userId = localStorage.getItem('userId');
		
		if (authToken && userId) {
			try {
				const decodedToken = jwtDecode<CustomJwtPayload>(authToken);
				
				const currentTime = Date.now() / 1000;
				if (decodedToken.exp && decodedToken.exp > currentTime) {
					dispatch(login({
						accessToken: authToken,
						permissions: decodedToken.permissions || [],
					}));
					
					ApiBase.putAccessTokenInfo(authToken);
					CacheService.setAuthToken(authToken);
					
					console.log('✅ App: Auth state restored from localStorage');
				} else {
					console.log('⚠️ App: Token expired, clearing auth data');
					localStorage.removeItem('authToken');
					localStorage.removeItem('userId');
					CacheService.clearAll();
				}
			} catch (error) {
				console.error('❌ App: Invalid token, clearing auth data:', error);
				localStorage.removeItem('authToken');
				localStorage.removeItem('userId');
				CacheService.clearAll();
			}
		}
	}, [dispatch]);
	
	return (
		<ThemeProvider theme={theme}>
			<CssBaseline/>
			<ScrollToTop>{routing}</ScrollToTop>
		</ThemeProvider>
	);
}

export default App;
